import CookieButton from "./CookieButton.svelte"
import NewsListe from "./NewsListe.svelte"
import Placeholder from "./Placeholder.svelte"
import PositionListe from "./PositionListe.svelte"
import StandpunkteArchivListe from "./StandpunkteArchivListe.svelte"
import StandpunkteListe from "./StandpunkteListe.svelte"
import StellenangeboteListe from "./StellenangeboteListe.svelte"
import SuchErgebnisse from "./SuchErgebnisse.svelte"
import TeamListe from "./TeamListe.svelte"
import VeranstaltungenListe from "./VeranstaltungenListe.svelte"
import VideoJs from "./VideoJs.svelte"

export default {
    newsListe: NewsListe,
    positionenListe: PositionListe,
    standpunkteListe: StandpunkteListe,
    standpunkteArchivListe: StandpunkteArchivListe,
    teamListe: TeamListe,
    stellenangeboteListe: StellenangeboteListe,
    veranstaltungenListe: VeranstaltungenListe,
    suchErgebnisse: SuchErgebnisse,
    cookieButton: CookieButton,
    videoJs: VideoJs,
    placeholder: Placeholder,
}
